/* Chart helper module */

import d3Utils from '../../../utils/d3Utils';
import chartUtils from '../../../utils/chart-utils';

var chartHelper = function chartHelper() {

    // Returns updated AggregationType using custom logic
    var modifyAggregationType = function modifyAggregationType(aggregationType) {
        if (aggregationType === chartUtils.aggregationTypes.unknown) {
            aggregationType = chartUtils.aggregationTypes.sum;
        }
        return aggregationType;
    };

    // Returns updated LegendLocation using custom logic
    var modifyLegendLocation = function modifyLegendLocation(legendLocation) {
        if (legendLocation === chartUtils.legendLocation.unknown) {
            legendLocation = chartUtils.legendLocation.left;
        }
        return legendLocation;
    };

    // Returns updated CrumbFieldConfig using custom logic
    var modifyCrumbFieldConfig = function modifyCrumbFieldConfig(crumbFieldConfig) {
        if (crumbFieldConfig !== null && Object.keys(crumbFieldConfig).length > 0) {
            return crumbFieldConfig;
        }
        return {
            '{crumbMetaName}': '{crumbFieldName}'
        };
    };

    // Returns updated CrumbDisplayFieldName using custom logic
    var modifyCrumbDisplayFieldName = function modifyCrumbDisplayFieldName(crumbDisplayFieldName, crumbFieldConfig) {
        if (crumbFieldConfig !== null && Object.keys(crumbFieldConfig).length > 0) {
            return crumbDisplayFieldName;
        }
        return '{crumbDisplayFieldName}';
    };

    // Returns updated YAxisNames using custom logic
    var modifyYAxisNames = function modifyYAxisNames(yAxisNames) {
        if (yAxisNames === null) {
            return [''];
        }
        return yAxisNames;
    };

    // Returns updated LegendLineCount using custom logic
    var modifyLegendLineCount = function modifyLegendLineCount(legendLineCount) {
        if (legendLineCount === 0) {
            return 1;
        }
        return legendLineCount;
    };

    // Returns updated YAxisFields using custom logic
    var modifyYAxisFields = function modifyYAxisFields(yAxisFields) {
        if (yAxisFields === null) {
            return [''];
        }
        return yAxisFields;
    };

    // Returns updated TotalLabel using custom logic
    var modifyTotalLabel = function modifyTotalLabel(totalLabel) {
        if (totalLabel === null) {
            return 'Total';
        }
        return totalLabel;
    };

    // Update chart config properties
    var modifyChartConfigProperties = function modifyChartConfigProperties(config) {
        var _config$ChartConfig = config.ChartConfig,
            LegendLocation = _config$ChartConfig.LegendLocation,
            AggregationType = _config$ChartConfig.AggregationType,
            CrumbFieldConfig = _config$ChartConfig.CrumbFieldConfig,
            CrumbDisplayFieldName = _config$ChartConfig.CrumbDisplayFieldName;


        config.ChartConfig.LegendLocation = modifyLegendLocation(LegendLocation);
        config.ChartConfig.AggregationType = modifyAggregationType(AggregationType);
        config.ChartConfig.CrumbFieldConfig = modifyCrumbFieldConfig(CrumbFieldConfig);
        config.ChartConfig.CrumbDisplayFieldName = modifyCrumbDisplayFieldName(CrumbDisplayFieldName, CrumbFieldConfig);
        return config;
    };

    return {
        modifyLegendLocation: modifyLegendLocation,
        modifyAggregationType: modifyAggregationType,
        modifyCrumbFieldConfig: modifyCrumbFieldConfig,
        modifyCrumbDisplayFieldName: modifyCrumbDisplayFieldName,
        modifyYAxisNames: modifyYAxisNames,
        modifyLegendLineCount: modifyLegendLineCount,
        modifyYAxisFields: modifyYAxisFields,
        modifyTotalLabel: modifyTotalLabel,
        modifyChartConfigProperties: modifyChartConfigProperties
    };
};

export default chartHelper();